import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header-links',
  templateUrl: './header-links.component.html',
  styleUrls: ['./header-links.component.scss']
})
export class HeaderLinksComponent {
  @Input() public isCombinedApplication: boolean = false;
}
